// API urls
export const LOGIN_URL = "bo-login/login/";
export const UPDATE_PASSWORD_URL = "bo-login/update-password/";
export const LOGIN_VERIFY_URL = "bo-login/verify/";
export const OTP_LOGIN_URL = "bo-login/verify-otp/";
export const FIRST_TIME_PASSWORD_URL = "bo-login/set-password/";
export const SIGNUP_URL = "register/";
export const FILTER_OPTIONS_URL = "configuration/filters/";
export const LIST_SUPERVISOR_URL = "supervisor-assignment/get-all-supervisors/";
export const LIST_ROLE_URL = "bo-user/get-all-roles/";
export const LIST_WORKER_GROUP_URL =
  "supervisor-assignment/get-all-worker-groups/";
export const LIST_UNSUPERVISED_WORKER_GROUP_URL = (pk) =>
  `supervisor-assignment/${pk}/get-unsupervised-worker-groups/`;
export const SUPERVISOR_URL = "supervisor-assignment/";
export const PRE_ASSIGN_CHECK_URL = "supervisor-assignment/pre-assign-check/";
export const WORKER_GROUP_PRE_ASSIGN_CHECK_URL =
  "supervisor-assignment/worker-group-pre-assign-check/";
export const SUPERVISOR_ASSIGN_URL = "supervisor-assignment/assign/";
export const ROLE_BULK_ASSIGN_URL = "bo-user/bulk-assign-role/";
export const WORKER_GROUP_ASSIGN_URL =
  "supervisor-assignment/worker-group-assign/";
export const SUPERVISOR_REMOVE_URL = "supervisor-assignment/remove/";
export const WORKER_REMOVE_URL = "supervisor-assignment/worker-group-remove/";
export const USER_URL = "user/";
export const NEW_USER_URL = "new-user/";
export const APP_USER_PROFILE = "user/profile-upload/";
export const APP_USER_PROFILE_RESULT = "user/profile-upload-result/";
export const BO_USER_PROFILE = "bo-user/profile-upload/";
export const BO_USER_PROFILE_RESULT = "bo-user/profile-upload-result/";
export const BO_USER_URL = "bo-user/";
export const WORKER_URL = "worker/";
export const WORKER_TYPES_URL = "worker/types/";
export const ROLES_URL = "role/";
export const GRIEVANCE_ROLES_URL = "/grievance/roles/";
export const ID_TYPES_URL = "idcard/";
export const BANNER_URL = "banner/";
export const BANNER_TITLE_URL = "banner/policy-list/";
export const AUDIT_API_LOG_URL = "audit-api-log/";
export const AUDIT_EXCEL_LOG_URL = "audit-excel-log/";
export const SMTP_URL = "smtp-settings/";
export const PUSHNOTIFICATION_SETTINGS_URL = "push-notification-setting/";
export const SUPERVISOR_BULK_URL = "supervisor-assignment/bulk/";
export const SUPERVISOR_BULK_RESULT_URL = "supervisor-assignment/bulk-result/";
export const SMS_URL = "sms/";
export const MESSAGE_SETTINGS_URL = "message-settings/";
export const REMARKS_URL = "attendance-type/";
export const ATTENDANCE_SUMMARY_URL = "attendance/summary/";
export const ATTENDANCE_BY_MONTH_URL = "attendance/by-month";
export const DASHBOARD_SUMMARY_URL = "summary/";
export const WORKER_ACCESS_SUMMARY_URL = "report/worker-access-summary";
export const WORKER_DETAILED_REPORT_URL = "report/worker-module-access-detailed";
export const BO_ACCESS_MOBILE_REPORT_URL = "report/bo-user-module-access-detailed";
export const BO_ACCESS_PORTAL_REPORT_URL = "report/backoffice-access-detailed";
export const BO_MODULE_ACCESS_URL = "report/bo-user-module-access";
export const BO_PORTAL_ACCESS_URL = "report/backoffice-access";
export const WORKER_MODULE_ACCESS_URL = "report/worker-module-access";
export const POLICY_DETAILS_URL = "report/policy-detailed/";
export const POLICY_SUMMARY_URL = "report/policy/";
export const HQVIEW_URL = "report/attendance/";


export const ATTENDANCE_URL = "attendance/";
export const ATTENDANCE_TYPE_URL = "attendance-type/";
export const APP_FEATURE_CONTROL_URL = "feature-control/";
export const ESTATE_SETUP_URL = "estate/upload/";
export const ESTATE_URL = "estate/";
export const ESTATE_QR_DOWNLOAD_URL = "location/download-qr/";
export const ESTATE_QR_PRINT_URL = "location/print-qr/";
export const ESTATE_UPLOAD_RESULT_URL = "estate/upload-result/";
export const USER_STATUS = "user/status/";
export const BO_USER_STATUS = "bo-user/status/";
export const ROLE_STATUS = "role/status/";
export const USER_PROFILE_VIEW = "bo-user/profile-view/";
export const WORKER_QR_URL = "worker/download-qr/";
export const WORKER_QR_PRINT_URL = "worker/print-qr/";
export const LANGUAGE_URL = "/user/language/";
export const ERML_SETTINGS_URL = "erml-setting/";
export const NATIONALITIES_LIST_URL = "configuration/nationalities/";
export const NATIONALITIES_FAV_LIST_URL = "/configuration/nationalities/favourites/";
export const ACCOUNT_DELETION_URL = "account-deletion/";
export const WORKER_CONTRACT_URL = "user-contract/";
export const PASSPORT_STATUS_URL = "/worker/passport-status/";
export const PASSPORT_RENEWAL_STATUS_URL = "/worker/passport-renewal-status/";
export const PERMIT_STATUS_URL = "/worker/permit-status/";
export const PERMIT_RENEWAL_STATUS_URL = "/worker/permit-renewal-status/";
export const SOURCE_FETCH_URL = "/source/";

export const COMPANY_FETCH_URL= "/company/";
export const ROLEMAPPING_FETCH_URL="/role-mapping/";


//Grievance Urls

export const COMMENT_URL = "grievance-comment/";
export const GRIEVANCE_URL = "grievance/";
export const GRIEVANCE_SMS_RESPONSE_URL = "grievance/send-sms/";
export const GRIEVANCE_STATUS = "grievance/status-choices/";
export const INTERNAL_GRIEVANCE_STATUS = "grievance/internal-status-choices/";
export const GRIEVANCE_TRANSLATION = "grievance/translate/";
export const GRIEVANCE_TRANSLATION_RESULT = "grievance/translation-result/";
export const GRIEVANCE_LANGUAGE_CHOICES = "grievance/language-choices/";
export const GRIEVANCE_URGENCY_LEVELS = "urgency-level/";
export const GRIEVANCE_TYPE = "grievance-type/";
export const GRIEVANCE_ASSIGNEE_CONTROL = "grievance-assignee-control/";
export const GRIEVANCE_ASSIGNEE = "grievance-assignee/";

// MOHR URLS
export const MOHR_TERRITORIES_URL = "mohr-branch/territories/";

// SOS URLS
export const SOS_URL = "sos/";
export const SOS_STATUS = "sos/status/";
export const SOS_TRANSLATION = "sos/translate/";
export const SOS_LANGUAGE_CHOICES = "sos/language-choices/";
export const SOS_TRANSLATION_COUNT = "sos/translation-count/";
export const SOS_TRANSLATION_RESULT = "sos/translation-result/";

// Should add worker id after SOS_ATTENDEE
export const SOS_ATTENDEE = "sos/attendees/";
export const SOS_RECIPIENT = "sos-recipient/";

// LOCATION URLS
export const ZONE_FETCH_URL = "location/zone/";
export const REGION_FETCH_URL = "location/region/";
export const ESTATE_FETCH_URL = "location/estate/";
export const DIVISION_FETCH_URL = "location/division/";
export const BLOCK_FETCH_URL = "location/block/";
export const STATE_FETCH_URL = "location/state/";
export const WORKER_FETCH_URL = "worker/all-list/";
export const DISTRICT_FETCH_URL = "location/district/";
export const DISTRICT_URL = "district/";
export const STATE_URL = "state/";
export const SOURCE_URL = "source/";
export const COMPANY_URL = "company/";
export const ROLEMAPPING_URL = "role-mapping/";




export const GLOBAL_CONFIGURATION_URL = "configuration/config-update/";

// NON WORKING DAYS URLS
export const NON_WORKING_DAY_HOLIDAY_URL = "non-working-days/holiday/";
export const NON_WORKING_DAY_SPECIFIC_URL = "non-working-days/specific/";
export const NON_WORKING_DAY_WEEKEND_URL = "non-working-days/weekend/";
export const HARI_TERABAI_DAY_URL = "non-working-days/hari-terabai/";

// CUSTOM FIELDS URLS
export const WORKER_GROUP_URL = "worker-group/";
export const UNSUPERVISED_WORKER_GROUP_URL =
  "unsupervised-worker-groups-of-estate/";
export const GRIEVANCE_TYPE_URL = "grievance-type/";
export const URGENCY_LEVEL_URL = "urgency-level/";

// SHOP AND MOHR BRANCH URLS
export const MOHR_BRANCH_URL = "mohr-branch/";
export const MOHR_BRANCH_BO_LIST_URL = "mohr-branch/bo-list/";
export const SHOP_URL = "shop/";
export const BO_LIST_SHOP_URL = "shop/bo-list/";
export const SMS_REPORT_URL = "sms-trxn/";

export const FORCE_UPDATE_URL = "force-update/";

export const STORAGE_CONSTANT = {
  TOKEN: "token",
  ID: "id",
  USERNAME: "username",
  MODULES: "modules",
  NEW_MODULES: "new_modules",
  ROLES: "roles",
};

export const PHONE_NUMBER_KEYS = ["mobile_number", "office_number"];

export const ITEM_URL = {
  WORKER: "/worker",
  BACK_OFFICE: "/backoffice",
  ROLE: "/role",
  PENDING_APPROVAL: "/pending-approval",
  ATTENDANCE_RECORD: "/attendance",
  ATTENDANCE_RECORD_BY_MONTH: "/attendancebymonth",
  ATTENDANCE_SUMMARY: "/summary",
  SUPERVISOR_ASSIGNMENT: "/supervisor-assignment",
  BULK_SUPERVISOR_ASSIGNMENT: "/bulk-supervisor-assignment",
  ERML: "/erml",
  ATTENDANCE_SETUP: "/setup-attendance",
  SOS: "/sos",
  SOS_SETUP: "/setup",
  GRIEVANCE: "/grievance",
  MOBILE: "/mobile",
  SYSTEM: "/system",
  EXTRAS: "/extra",
  BANNER: "/banner",
  ESTATE: "/estate",
  GRIEVANCE_SETUP: "/setup",
  UPLOAD_FILE: "/upload",
  AUDIO_TRANSLATION: "/audio",
  NOTIFICATION_SETTING: "/notification",
  MOHR_BRANCH_SETUP: "/branch-setup",
  KEDAI_CONTACT_LIST: "/contact-list",
  AUDIT_TRIAL_SETUP: "/audit-setup",
  SMS_REPORT: "/sms-report",
  AUDIT_TRIAL_TRANSACTION: "/audit-transaction",
  AUDIT_USER_MANAGEMENT: "/user-setup",
  AUDIT_USER_LOG: "/user-log",
  AUDIT_TRIAL_USER: "/audit-user",
  AUDIT_LOG_FILE: "/log-file",
  ATTENDANCE_REPORT: "/attendance-report",
  POLICY_REPORT: "/policy-report",
  BACKOFFICE_ACCESS_REPORT : "/backofficeaccessreport",
  WORKER_ACCESS_REPORT : "/workeraccessreport"


};
export const MAIN_URL = {
  DASHBOARD: "/dashboard",
  ATTENDANCE: "/attendance",
  USER: "/user",
  SOS: "/sos",
  GRIEVANCE: "/grievance",
  CONFIGURATIONS: "/configurations",
  ANNOUNCEMENT: "/announcement",
  MOHR_BRANCH: "/mohr-branch",
  KEDAI_FGV: "/kedai-fgv",
  AUDIT_TRIAL: "/audit",
  REPORT: "/report",
};

export const SUB_ITEM_URL = {
  WORKER_LIST: "/record",
  WORKER_CONTRACTS: "/contracts",
  BO_LIST: "/record",
  ROLE_LIST: "/record",
  PENDING_APPROVAL_LIST: "/record",
  NON_PENDING_USERS: "/non-pending-users",
  REJECTED_USERS: "/rejected",
  REJECTED_PROFILES: "/rejected-profiles",
  NON_PENDING_PROFILES: "/non-pending-profiles",
  PENDING_APPROVAL_PROFILE: "/pending-profile-update",
  DASHBOARD: "/dashboard",
  ATTENDANCE_LIST: "/record",
  ATTENDANCE_BY_MONTH_LIST: "/bymonthrecord",
  ATTENDANCE_SUMMARY: "/view",
  SUPERVISOR_ASSIGNMENT_LIST: "/record",
  BULK_SUPERVISOR_ASSIGN: "/assign",
  ERML_FILE_DOWNLOAD: "/submit",
  ATTENDANCE_METHOD: "/method",
  ATTENDANCE_TYPE: "/type",
  PUSH_NOTIFICATION_SETTINGS: "/push-notification-settings",
  ESTATE_UPLOAD: "/estate-upload",
  ESTATE_QR: "/estate-qr",
  ERML_SETTINGS: "/erml-settings",
  NON_WORKING_DAY_GLOBAL: "/non-working-day/holiday",
  NON_WORKING_DAY_WEEKEND: "/non-working-day/weekend",
  NON_WORKING_DAY_HARI_TERABAI: "/non-working-day/hari-terabai",
  SOS_LIST: "/record",
  SOS_COUNT: "/count",
  SOS_RECIPIENT: "/recipient",
  GRIEVANCE_LIST: "/record",
  MOBILE_NUMBER_CHANGE: "/change",
  NEW_USER_REQUEST: "/new-user-request",
  FEATURE_CONTROL_MODULE: "/module",
  FEATURE_CONTROL_OTHERS: "/others",
  BANNER_COUNT: "/banner-count",
  BANNER_LIST: "/banner",
  UPLOAD_SIZE: "/upload-size",
  AUDIO_SETTINGS: "/audio",
  TRANSLATION_COUNT: "/translation-count",
  MESSAGE_SETTINGS: "/message",
  MESSAGE_NOTIFICATION: "/push-notification-settings",
  CUSTOM_FIELDS: "/custom",
  CUSTOM_FIELDS_WORKER_GROUP: "/custom-worker-group",
  CUSTOM_FIELDS_ID_TYPES: "/custom-id-type",
  CUSTOM_FIELDS_DISTRICT: "/district",
  CUSTOM_FIELDS_STATE: "/state",
  SMTP_SETTINGS: "/smtp-settings",
  ESTATE: "/record",
  GRIEVANCE_ASSIGNEE: "/assignee",
  APP_USER_PROFILE: "/app-user-profile",
  CUSTOM_FIELDS_GRIEVANCE_TYPE: "/grievance-type",
  CUSTOM_FIELDS_URGENCY_LEVEL: "/urgency-level",
  CUSTOM_FIELDS_SOURCE: "/source",
  CUSTOM_FIELDS_COMPANY: "/company",
  CUSTOM_FIELDS_ROLEMAPPING: "/role-mapping",
  MOHR_BRANCH_SETUP: "/setup",
  KEDAI_CONTACT_LIST: "/list",
  FORCE_UPDATE_SETTINGS: "/force-update-settings",
  ATTENDANCE_WORKER_GROUP: "/worker-group",
  AUDIT_TRANSLATION_COUNT: "/audit-translation-count",
  AUDIT_ROLE_SETUP: "/audit-role-setup",
  AUDIT_AUDIO_SETUP: "/audit-audio-setup",
  AUDIT_SOS_TRANSACTION: "/audit-sos-transaction",
  AUDIT_GRIEVANCE_TRANSACTION: "/audit-grievance-transaction",
  AUDIT_WORKER_MANAGEMENT: "/worker-management",
  AUDIT_USER_MANAGEMENT: "/user-management",
  AUDIT_ATTENDANCE_SETUP_ATTENDANCE_TYPE:
    "/audit-attendance-setup/attendance-type",
  AUDIT_ATTENDANCE_SETUP_ATTENDANCE_METHOD:
    "/audit-attendance-setup/attendance-method",
  AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY:
    "/audit-attendance-setup/non-working-day",
  AUDIT_CUSTOM_SETUP_WORKER_GROUP: "/audit-custom/worker-group",
  AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE: "/audit-custom/grievance-type",
  AUDIT_CUSTOM_SETUP_URGENCY_LEAVE: "/audit-custom/urgency-leave",
  AUDIT_BO_MANAGEMENT: "/bo-management",
  AUDIT_USER_ACCESS_LOG: "/user-access",
  AUDIT_USER_ACTIVE_INACTIVE_LOG: "/user-active-inactive",
  AUDIT_USER_LAST_LOGIN_LOG: "/user-last-login",
  SMS_REPORT: "/sms-report",
  AUDIT_TRIAL_USER: "/audit-user",
  AUDIT_LOG_FILE: "/log-file",
  AUDIT_LOG_EXCEL: "/log-excel",
  AUDIT_BO_USER: "/bo-user",
  ACCOUNT_DELETION: "/account-deletion",
  REPORT_ESTATE_VIEW: "/estateview",
  REPORT_HQ_VIEW: "/hqview",
  POLICY_DASHBOARD: "/policy-dashboard",
  BACKOFFICE_MOBILE_APP: "/boaccessmobileapp",
  BACKOFFICE_MOBILE_APP_DETAILS: "/boaccessmobileappdetails",
  BACKOFFICE_BO_PORTAL: "/boaccessboportal",
  BACKOFFICE_BO_PORTAL_DETAILS: "/boaccessboportaldetails",
  WORKER_ACCESS_REPORT : "/workeraccessreport",
  WORKER_ACCESS: "/workeraccess",
  WORKER_ACCESS_BY_MODULE: "/workeraccessmodule",
  WORKER_ACCESS_DETAIL_REPORT: "/workeraccessdetailreport",
  POLICY_DETAILS: "/policy-details",
  BACKOFFICE_ACCESS_REPORT : "/backofficeaccessreport",
  POLICY_REPORT: "/policy-report",
  ATTENDANCE_REPORT: "/attendance-report",


};

export const URLS = {
  WORKER_LIST: MAIN_URL.USER + ITEM_URL.WORKER + SUB_ITEM_URL.WORKER_LIST,
  WORKER_CONTRACT_LIST:
    MAIN_URL.USER + ITEM_URL.WORKER + SUB_ITEM_URL.WORKER_CONTRACTS,
  BO_LIST: MAIN_URL.USER + ITEM_URL.BACK_OFFICE + SUB_ITEM_URL.BO_LIST,
  ROLE_LIST: MAIN_URL.USER + ITEM_URL.ROLE + SUB_ITEM_URL.ROLE_LIST,
  PENDING_APPROVAL_LIST:
    MAIN_URL.USER +
    ITEM_URL.PENDING_APPROVAL +
    SUB_ITEM_URL.PENDING_APPROVAL_LIST,
  REJECTED_USERS_LIST:
    MAIN_URL.USER + ITEM_URL.PENDING_APPROVAL + SUB_ITEM_URL.REJECTED_USERS,
  APPROVED_USERS_LIST:
    MAIN_URL.USER + ITEM_URL.PENDING_APPROVAL + SUB_ITEM_URL.NON_PENDING_USERS,
  NON_PENDING_USERS_LIST:
    MAIN_URL.USER + ITEM_URL.PENDING_APPROVAL + SUB_ITEM_URL.NON_PENDING_USERS,
  PENDING_APPROVAL_PROFILE:
    MAIN_URL.USER +
    ITEM_URL.PENDING_APPROVAL +
    SUB_ITEM_URL.PENDING_APPROVAL_PROFILE,
  NON_PENDING_PROFILE:
    MAIN_URL.USER +
    ITEM_URL.PENDING_APPROVAL +
    SUB_ITEM_URL.NON_PENDING_PROFILES,
  DASHBOARD: MAIN_URL.DASHBOARD,
  ATTENDANCE_LIST:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_RECORD +
    SUB_ITEM_URL.ATTENDANCE_LIST,
  ATTENDANCE_BY_MONTH_LIST:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_RECORD_BY_MONTH +
    SUB_ITEM_URL.ATTENDANCE_BY_MONTH_LIST,
  SUPERVISOR_ASSIGNMENT_LIST:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.SUPERVISOR_ASSIGNMENT +
    SUB_ITEM_URL.SUPERVISOR_ASSIGNMENT_LIST,
  BULK_SUPERVISOR_ASSIGN:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.SUPERVISOR_ASSIGNMENT +
    SUB_ITEM_URL.BULK_SUPERVISOR_ASSIGN,
  ERML_SUBMISSION:
    MAIN_URL.ATTENDANCE + ITEM_URL.ERML + SUB_ITEM_URL.ERML_FILE_DOWNLOAD,
  ERML_SETTINGS:
    MAIN_URL.ATTENDANCE + ITEM_URL.ERML + SUB_ITEM_URL.ERML_SETTINGS,
  ATTENDANCE_METHOD:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.ATTENDANCE_METHOD,
  ATTENDANCE_TYPE:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.ATTENDANCE_TYPE,
  ATTENDANCE_WORKER_GROUP:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.ATTENDANCE_WORKER_GROUP,
  PUSH_NOTIFICATION_SETTINGS:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.PUSH_NOTIFICATION_SETTINGS,
  ESTATE_UPLOAD:
    MAIN_URL.ATTENDANCE + ITEM_URL.ESTATE + SUB_ITEM_URL.ESTATE_UPLOAD,
  ESTATE: MAIN_URL.ATTENDANCE + ITEM_URL.ESTATE + SUB_ITEM_URL.ESTATE,
  NON_WORKING_DAY_GLOBAL:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.NON_WORKING_DAY_GLOBAL,
  NON_WORKING_DAY_WEEKEND:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.NON_WORKING_DAY_WEEKEND,
  NON_WORKING_DAY_HARI_TERABAI:
    MAIN_URL.ATTENDANCE +
    ITEM_URL.ATTENDANCE_SETUP +
    SUB_ITEM_URL.NON_WORKING_DAY_HARI_TERABAI,
  WORKER_GROUP:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_WORKER_GROUP,
  SOS_LIST: MAIN_URL.SOS + ITEM_URL.SOS + SUB_ITEM_URL.SOS_LIST,
  SOS_COUNT: MAIN_URL.SOS + ITEM_URL.SOS_SETUP + SUB_ITEM_URL.SOS_COUNT,
  SOS_RECIPIENT: MAIN_URL.SOS + ITEM_URL.SOS_SETUP + SUB_ITEM_URL.SOS_RECIPIENT,
  KEDAI_LIST:
    MAIN_URL.KEDAI_FGV +
    ITEM_URL.KEDAI_CONTACT_LIST +
    SUB_ITEM_URL.KEDAI_CONTACT_LIST,
  MOHR_LIST:
    MAIN_URL.MOHR_BRANCH +
    ITEM_URL.MOHR_BRANCH_SETUP +
    SUB_ITEM_URL.MOHR_BRANCH_SETUP,
  GRIEVANCE_LIST:
    MAIN_URL.GRIEVANCE + ITEM_URL.GRIEVANCE + SUB_ITEM_URL.GRIEVANCE_LIST,
  GRIEVANCE_ASSIGNEE:
    MAIN_URL.GRIEVANCE +
    ITEM_URL.GRIEVANCE_SETUP +
    SUB_ITEM_URL.GRIEVANCE_ASSIGNEE,
  MOBILE_NUMBER_CHANGE:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.MOBILE +
    SUB_ITEM_URL.MOBILE_NUMBER_CHANGE,
  NEW_USER_REQUEST:
    MAIN_URL.CONFIGURATIONS + ITEM_URL.MOBILE + SUB_ITEM_URL.NEW_USER_REQUEST,
  FEATURE_CONTROL_MODULE:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.MOBILE +
    SUB_ITEM_URL.FEATURE_CONTROL_MODULE,
  FEATURE_CONTROL_OTHERS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.MOBILE +
    SUB_ITEM_URL.FEATURE_CONTROL_OTHERS,
  BANNER_COUNT:
    MAIN_URL.ANNOUNCEMENT + ITEM_URL.BANNER + SUB_ITEM_URL.BANNER_COUNT,
  
  BANNER_LIST:
    MAIN_URL.ANNOUNCEMENT + ITEM_URL.BANNER + SUB_ITEM_URL.BANNER_LIST,
  UPLOAD_SIZE:
    MAIN_URL.CONFIGURATIONS + ITEM_URL.SYSTEM + SUB_ITEM_URL.UPLOAD_SIZE,
  AUDIO_SETTINGS:
    MAIN_URL.CONFIGURATIONS + ITEM_URL.SYSTEM + SUB_ITEM_URL.AUDIO_SETTINGS,
  TRANSLATION_COUNT:
    MAIN_URL.CONFIGURATIONS + ITEM_URL.SYSTEM + SUB_ITEM_URL.TRANSLATION_COUNT,
  MESSAGE_SETTINGS:
    MAIN_URL.CONFIGURATIONS + ITEM_URL.SYSTEM + SUB_ITEM_URL.MESSAGE_SETTINGS,
  MESSAGE_NOTIFICATION:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.MESSAGE_NOTIFICATION,
  WORKER_GROUP_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_WORKER_GROUP,
  ID_TYPE_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_ID_TYPES,
  GRIEVANCE_TYPE_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_GRIEVANCE_TYPE,
  URGENCY_LEVEL_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_URGENCY_LEVEL,
  SOURCE_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_SOURCE,
  COMPANY_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_COMPANY,
  ROLEMAPPING_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_ROLEMAPPING,
  DISTRICT_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_DISTRICT,
  STATE_CUSTOM_FIELDS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.CUSTOM_FIELDS_STATE,
  SMTP_SETTINGS:
    MAIN_URL.CONFIGURATIONS + ITEM_URL.SYSTEM + SUB_ITEM_URL.SMTP_SETTINGS,
  FORCE_UPDATE_SETTINGS:
    MAIN_URL.CONFIGURATIONS +
    ITEM_URL.SYSTEM +
    SUB_ITEM_URL.FORCE_UPDATE_SETTINGS,
  AUDIT_ROLE_SETUP:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_ROLE_SETUP,
  AUDIT_AUDIO_SETUP:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_AUDIO_SETUP,
  AUDIT_SOS_TRANSACTION:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_SOS_TRANSACTION,
  AUDIT_GRIEVANCE_TRANSACTION:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_TRANSACTION +
    SUB_ITEM_URL.AUDIT_GRIEVANCE_TRANSACTION,
  AUDIT_TRANSLATION_COUNT:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_TRANSLATION_COUNT,
  AUDIT_WORKER_MANAGEMENT:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_USER_MANAGEMENT +
    SUB_ITEM_URL.AUDIT_WORKER_MANAGEMENT,
  AUDIT_ATTENDANCE_SETUP_ATTENDANCE_TYPE:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_TYPE,
  AUDIT_ATTENDANCE_SETUP_ATTENDANCE_METHOD:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_METHOD,
  AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY,
  AUDIT_CUSTOM_SETUP_WORKER_GROUP:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_CUSTOM_SETUP_WORKER_GROUP,
  AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE,
  AUDIT_CUSTOM_SETUP_URGENCY_LEAVE:
    MAIN_URL.AUDIT_TRIAL +
    ITEM_URL.AUDIT_TRIAL_SETUP +
    SUB_ITEM_URL.AUDIT_CUSTOM_SETUP_URGENCY_LEAVE,
  SMS_REPORT:
    MAIN_URL.AUDIT_TRIAL + ITEM_URL.SMS_REPORT + SUB_ITEM_URL.SMS_REPORT,
  AUDIT_TRIAL_USER:
    MAIN_URL.AUDIT_TRIAL + ITEM_URL.AUDIT_TRIAL_USER + SUB_ITEM_URL.AUDIT_TRIAL_USER,
  AUDIT_LOG_FILE:
    MAIN_URL.AUDIT_TRIAL + ITEM_URL.AUDIT_LOG_FILE + SUB_ITEM_URL.AUDIT_LOG_FILE,
  AUDIT_BO_USER:
    MAIN_URL.AUDIT_TRIAL + ITEM_URL.AUDIT_TRIAL_USER + SUB_ITEM_URL.AUDIT_BO_USER,
  WORKER_ACCESS_REPORT:
    MAIN_URL.REPORT + ITEM_URL.WORKER_ACCESS_REPORT + SUB_ITEM_URL.WORKER_ACCESS_REPORT,
  BACKOFFICE_ACCESS_REPORT:
    MAIN_URL.REPORT + ITEM_URL.BACKOFFICE_ACCESS_REPORT + SUB_ITEM_URL.BACKOFFICE_ACCESS_REPORT,
  POLICY_REPORT:
    MAIN_URL.REPORT + ITEM_URL.POLICY_REPORT + SUB_ITEM_URL.POLICY_REPORT, 
  ATTENDANCE_REPORT:
    MAIN_URL.REPORT + ITEM_URL.ATTENDANCE_REPORT + SUB_ITEM_URL.ATTENDANCE_REPORT, 
    
  
  LOGIN: "/",
  LOGIN_OTP: "/login-otp",
  LOGIN_FIRST_TIME_PASSWORD: "/login-password-register",
  LOGIN_PASSWORD: "/login-password",
  CREATE_FIRST_TIME_PASSWORD: "/create-password",
};

// Frontend URLS
export const ROUTE_URL = {
  HOME: "/sos/record",
  ATTENDANCE_LIST: "/attendance/record",
  ATTENDANCE_BY_MONTH_LIST: "/attendancebymonth/record",
  ATTENDANCE_METHOD: "/configurations/attendance-method",
  PUSH_NOTIFICATION: "/configurations/push-notification-settings",
  ROLE: "/user/role",
  SUPERVISOR_LIST: "/configurations/supervisor-assignment",
  USER_LIST: "/user/record",
  SOS_LIST: "/sos/record",
  ANNOUNCEMENT: "/announcement/banner",
  GRIEVANCE_LIST: "/grievance/record",
  BO_USER_LIST: "/user/backoffice",
  WORKER_LIST: "/user/worker",
  ATTENDANCE_WORKER_GROUP: "/worker-group/record",
};

export const MODULES = {
  DASHBOARD: "Dashboard",
  ATTENDANCE_MANAGEMENT: "Attendance Management",
  SOS_MANAGEMENT: "SOS Management",
  GRIEVANCE_MANAGEMENT: "Grievance Management",
  USER_MANAGEMENT: "User Management",
  ANNOUNCEMENT_MANAGEMENT: "Announcement Management",
  ATTENDANCE_METHOD: "Attendance Method",
  ATTENDANCE_REMARKS: "Attendance Remarks",
  PUSH_NOTIFICATION_SETTINGS: "Push Notification Settings",
  HASIL_TYPES: "Hasil Type",
  ERML_FILE_SUBMISSION: "ERML File Submission",
  SOS_SETTINGS: "SOS_SETTINGS",
  CONFIGURATION: "Configuration",
  WORKER_USER: "Worker User",
  BACKOFFICE_USER: "BackOffice User",

  ROLE: "Role",
  PENDING_APPROVAL: "Pending Approval",
  ATTENDANCE_RECORD: "Attendance Record",
  ATTENDANCE_RECORD_BY_MONTH: "Attendance Record by month",
  // ATTENDANCE_RECORD_BY_MONTH: "Attendance report by month",
  ATTENDANCE_SUPERVISOR_ASSIGNMENT: "Attendance Supervisor Assignment",
  ATTENDANCE_BULK_SUPERVISOR_ASSIGNMENT:
    "Assignment Bulk Supervisor Assignment",
  ATTENDANCE_ERML_SUBMISSION: "Attendance ERML Submission",
  ATTENDANCE_SETUP: "Attendance Setup",
  SOS_RECORD: "SOS Record",
  SOS_SETUP: "SOS Setup",
  MOBILE_APP_CONFIGURATION: "Mobile App Configuration",
  SYSTEM_CONFIGURATION: "System Configuration",
  ATTENDANCE_WORKER_GROUP: "Attendance Worker Group",
};

export const ATTENDANCE_METHODS = {
  WORKER_SCANS: "Worker scans QR code",
  SUPERVISOR_SCANS: "Supervisor scans QR code of the worker",
  BOTH_SCANS: "Both worker and supervisor scans QR code",
};

export const USER_STATUS_CHOICES = [
  {
    id: "Active",
    name: "Active",
  },
  {
    id: "Inactive",
    name: "Inactive",
  },
  {
    id: "Pending",
    name: "Pending",
  },
  {
    id: "Rejected",
    name: "Rejected",
  },
];

export const PAGE_NAME = {
  DASHBOARD: "Dashboard",
  BANNER: "Banners",
  BANNER_COUNT: "Display Count Control",
  WORKER_USER: "Worker User",
  WORKER_FILE_UPLOAD: "Worker File Upload",
  WORKER_CONTRACT: "Worker Contract T&C",
  WORKER_CONTRACT_UPLOAD: "Worker Contract Upload",
  BACK_OFFICE_USER: "Back Office User",
  BACK_OFFICE_FILE_UPLOAD: "BO User File Upload",
  ROLE: "Role",
  PENDING_USER: "Pending Users",
  APPROVED_OR_REJECTED_USER: "Approved/Rejected User",
  PENDING_PROFILE_DATA: "Pending Profile Update",
  APPROVED_OR_REJECTED_PROFILE: "Approved/Rejected Profile Update",
  ATTENDANCE_RECORD: "Attendance Record",
   ATTENDANCE_RECORD_BY_MONTH: "Attendance Record by month",
  // ATTENDANCE_RECORD_BY_MONTH: "Attendance report by month",
  SUPERVISOR_ASSIGNMENT: "Supervisor Assignment",
  BULK_SUPERVISOR_ASSIGNMENT: "Bulk Supervisor Assignment",
  ERML_FILE_DOWNLOAD: "ERML File Download",
  ERML_SETTINGS: "ERML Settings",
  ATTENDANCE_METHOD: "Attendance Method",
  ATTENDANCE_TYPE: "Attendance Type",
  PUSH_NOTIFICATION: "Push Notification",
  NON_WORKING_DAY: "Non Working Day",
  ESTATE: "Estate",
  ESTATE_FILE_UPLOAD: "Estate File Upload",
  ESTATE_QR: "Estate QR Code",
  SOS_RECORD: "SOS Record",
  DAILY_SUBMISSION_LIMIT: "Daily Submission Limit",
  SOS_RECIPIENT: "SOS Recipient",
  GRIEVANCE_RECORDS: "Grievance Records",
  ASSIGNEE: "Assignee",
  MOBILE_CHANGE: "Mobile No. Change Flag",
  NEW_USER_REQUEST: "New User Request",
  FEATURE_CONTROL: "Feature Control",
  UPLOAD_FILE_SIZE_SETTING: "Upload File Size Setting",
  AUDIO_SETTING: "Audio Setting ",
  MAX_TRANSLATION_COUNT: "Max Translation Count",
  NOTIFICATION_SETTING: "Notification Setting",
  CUSTOM_FIELD: "Custom Field",
  SMTP_SETTINGS: "SMTP Settings",
  MOHR_BRANCH_SETUP: "Branch Setup",
  KEDAI_CONTACT_LIST: "Contact List",
  FORCE_UPDATE_SETTINGS: "Force Update Settings",
  ATTENDANCE_WORKER_GROUP: "Attendance Worker Group",
  AUDIT_ROLE_SETUP: "Role Setup",
  AUDIT_ATTENDANCE_SETUP: "Attendance Setup",
  AUDIT_CUSTOM_SETUP: "Custom",
  AUDIT_AUDIO_SETUP: "Audio Setup",
  AUDIT_WORKER_USER: "Worker Last Login",
  AUDIT_BACKOFFICE_USER: "Backoffice Last Login",
  AUDIT_LOG_API: "Audit Log API",
  AUDIT_LOG_EXCEL: "Audit Log Excel",
  REPORT_HQ_VIEW: "HQ View",
  REPORT_ESTATE_VIEW: "Estate View",
  POLICY_DASHBOARD: "Policy Dashboard",
  BACKOFFICE_MOBILE_APP: "BO Access Mobile App",
  WORKER_ACCESS_REPORT: "Worker Access Report",
  BACKOFFICE_ACCESS_REPORT: "Backoffice Access Report",
  POLICY_REPORT: "Policy Report",
  ATTENDANCE_REPORT: "Attendance Report",
  WORKER_ACCESS: "Worker Access",
  WORKER_ACCESS_BY_MODULE: "Worker Access - By Module",
  WORKER_ACCESS_DETAIL_REPORT: "Worker Access Detail Report",
  BACKOFFICE_MOBILE_APP_DETAILS: "BO Access Mobile App (Details)",
  BACKOFFICE_BO_PORTAL: "BO Access BO Portal",
  BACKOFFICE_BO_PORTAL_DETAILS: "BO Access BO Portal (Details)",
  POLICY_DETAILS: "Policy Details",
  AUDIT_TRANSLATION_COUNT: "Translation Count",
  AUDIT_SOS_TRANSACTION: "Audit SOS Transaction",
  AUDIT_GRIEVANCE_TRANSACTION: "Audit Grievance Transaction",
  AUDIT_WORKER_MANAGEMENT: "Worker User Management",
  AUDIT_BO_MANAGEMENT: "BO User Management",
  AUDIT_USER_ACCESS_LOG: "User Access Log",
  AUDIT_USER_ACTIVE_INACTIVE_LOG: "User Active Inactive Log",
  AUDIT_USER_LAST_LOGIN_LOG: "User Last Login Log",
  SMS_REPORT: "SMS Report",
  ACCOUNT_DELETION: "Delete Account Request",
};

export const PAGES = {
  [PAGE_NAME.DASHBOARD]: ["View"],
  [PAGE_NAME.BANNER]: ["View", "Add", "Edit", "Delete", "View Details"],
  [PAGE_NAME.BANNER_COUNT]: ["View"],
  [PAGE_NAME.WORKER_USER]: [
    "View",
    "Add",
    "Edit",
    "Delete",
    "Download",
    "View Details",
  ],
  [PAGE_NAME.WORKER_FILE_UPLOAD]: ["View", "Download"],
  [PAGE_NAME.BACK_OFFICE_USER]: [
    "View",
    "Add",
    "Edit",
    "Delete",
    "Download",
    "View Details",
  ],
  [PAGE_NAME.BACK_OFFICE_FILE_UPLOAD]: ["View", "Download"],
  [PAGE_NAME.ROLE]: ["View", "Add", "Edit", "View Details"],
  [PAGE_NAME.PENDING_USER]: ["View", "Edit", "Change Status", "View Details"],
  [PAGE_NAME.APPROVED_OR_REJECTED_USER]: ["View", "Edit", "View Details"],
  [PAGE_NAME.PENDING_PROFILE_DATA]: [
    "View",
    "Edit",
    "Change Status",
    "View Details",
  ],
  [PAGE_NAME.APPROVED_OR_REJECTED_PROFILE]: ["View", "Edit"],
  [PAGE_NAME.ATTENDANCE_RECORD]: [
    "View",
    "Download",
    "Edit",
    "Delete",
    "Add",
    "View Details",
  ],
  [PAGE_NAME.ATTENDANCE_RECORD_BY_MONTH]: [
    "View",
    "Download",

  ],
  [PAGE_NAME.SUPERVISOR_ASSIGNMENT]: [
    "View",
    "Edit",
    "Download",
    "View Details",
  ],
  [PAGE_NAME.BULK_SUPERVISOR_ASSIGNMENT]: ["View", "Download"],
  [PAGE_NAME.ERML_FILE_DOWNLOAD]: ["View", "Download"],
  [PAGE_NAME.ERML_SETTINGS]: ["View"],
  [PAGE_NAME.ATTENDANCE_METHOD]: ["View"],
  [PAGE_NAME.ATTENDANCE_TYPE]: [
    "Add",
    "Edit",
    "Change Status",
    "View",
    "View Details",
  ],
  [PAGE_NAME.PUSH_NOTIFICATION]: ["View"],
  [PAGE_NAME.NON_WORKING_DAY]: [
    "View",
    "Add",
    "Edit",
    "Delete",
    "View Details",
  ],
  [PAGE_NAME.ESTATE]: ["View", "Download"],
  [PAGE_NAME.ESTATE_QR]: ["View", "Download"],
  [PAGE_NAME.ESTATE_FILE_UPLOAD]: ["View", "Download"],
  [PAGE_NAME.SOS_RECORD]: [
    "View",
    "Download",
    "Edit",
    "Delete",
    "View Details",
  ],
  [PAGE_NAME.DAILY_SUBMISSION_LIMIT]: ["View"],
  [PAGE_NAME.SOS_RECIPIENT]: ["Add", "Delete"],
  [PAGE_NAME.GRIEVANCE_RECORDS]: [
    "View",
    "View Anonymous",
    "Download",
    "Edit",
    "Delete",
    "View Details",
  ],
  [PAGE_NAME.AUDIT_WORKER_USER]: ["View","Download"],
  [PAGE_NAME.AUDIT_LOG_API]: ["View","Download"],
  [PAGE_NAME.WORKER_ACCESS_BY_MODULE]: ["View","Download"],
  [PAGE_NAME.AUDIT_LOG_EXCEL]: ["View","Download"],
  [PAGE_NAME.AUDIT_BACKOFFICE_USER]: ["View","Download"],
  [PAGE_NAME.ASSIGNEE]: ["View"],
  [PAGE_NAME.MOBILE_CHANGE]: ["View"],
  [PAGE_NAME.NEW_USER_REQUEST]: ["View"],
  [PAGE_NAME.FEATURE_CONTROL]: ["Change Status", "View", "Edit"],
  [PAGE_NAME.UPLOAD_FILE_SIZE_SETTING]: ["View"],
  [PAGE_NAME.AUDIO_SETTING]: ["View"],
  [PAGE_NAME.MAX_TRANSLATION_COUNT]: ["View"],
  [PAGE_NAME.FORCE_UPDATE_SETTINGS]: [],
  [PAGE_NAME.NOTIFICATION_SETTING]: ["View", "Add", "Edit", "Change Status"],
  [PAGE_NAME.CUSTOM_FIELD]: ["View", "Add", "Edit", "Change Status"],
  [PAGE_NAME.SMTP_SETTINGS]: ["View"],
  [PAGE_NAME.KEDAI_CONTACT_LIST]: [
    "View",
    "Add",
    "Edit",
    "Delete",
    "View Details",
  ],
  [PAGE_NAME.MOHR_BRANCH_SETUP]: [
    "View",
    "Add",
    "Edit",
    "Delete",
    "View Details",
  ],
  [PAGE_NAME.ATTENDANCE_WORKER_GROUP]: ["View", "Add", "Edit", "Delete"],
  [PAGE_NAME.AUDIT_ROLE_SETUP]: ["View", "Download"],
  [PAGE_NAME.AUDIT_ATTENDANCE_SETUP]: ["View", "Download"],
  [PAGE_NAME.AUDIT_CUSTOM_SETUP]: ["View", "Download"],
  [PAGE_NAME.AUDIT_AUDIO_SETUP]: ["View", "Download"],
  [PAGE_NAME.AUDIT_TRANSLATION_COUNT]: ["View", "Download"],
  [PAGE_NAME.AUDIT_SOS_TRANSACTION]: ["View", "Download"],
  [PAGE_NAME.AUDIT_GRIEVANCE_TRANSACTION]: ["View", "Download"],
  [PAGE_NAME.AUDIT_WORKER_MANAGEMENT]: ["View", "Download"],
  [PAGE_NAME.AUDIT_BO_MANAGEMENT]: ["View", "Download"],
  [PAGE_NAME.AUDIT_USER_ACCESS_LOG]: ["View", "Download"],
  [PAGE_NAME.AUDIT_USER_ACTIVE_INACTIVE_LOG]: ["View", "Download"],
  [PAGE_NAME.AUDIT_USER_LAST_LOGIN_LOG]: ["View", "Download"],
  [PAGE_NAME.SMS_REPORT]: ["View", "Download"],
  [PAGE_NAME.WORKER_ACCESS]: ["View"],
  [PAGE_NAME.WORKER_ACCESS_DETAIL_REPORT]: ["View", "Download"],
  [PAGE_NAME.BACKOFFICE_MOBILE_APP]: ["View"],
  [PAGE_NAME.BACKOFFICE_MOBILE_APP_DETAILS]: ["View", "Download"],
  [PAGE_NAME.BACKOFFICE_BO_PORTAL]: ["View"],
  [PAGE_NAME.BACKOFFICE_BO_PORTAL_DETAILS]: ["View", "Download"],
  [PAGE_NAME.POLICY_DASHBOARD]: ["View"],
  [PAGE_NAME.POLICY_DETAILS]: ["View", "Download"],
  [PAGE_NAME.REPORT_HQ_VIEW]: ["View", "Download"],
  [PAGE_NAME.POLICY_DETAILS]: ["View", "Download"],



};

export const DEFAULT_REDIRECT_URL = {
  [PAGE_NAME.DASHBOARD]: URLS.DASHBOARD,
  [PAGE_NAME.BANNER]: URLS.BANNER_LIST,
  [PAGE_NAME.BANNER_COUNT]: URLS.BANNER_COUNT,
  [PAGE_NAME.WORKER_USER]: URLS.WORKER_LIST,
  [PAGE_NAME.WORKER_FILE_UPLOAD]: URLS.WORKER_LIST,
  [PAGE_NAME.BACK_OFFICE_USER]: URLS.BO_LIST,
  [PAGE_NAME.BACK_OFFICE_FILE_UPLOAD]: URLS.BO_LIST,
  [PAGE_NAME.ROLE]: URLS.ROLE_LIST,
  [PAGE_NAME.PENDING_USER]: URLS.PENDING_APPROVAL_LIST,
  [PAGE_NAME.APPROVED_OR_REJECTED_USER]: URLS.APPROVED_USERS_LIST,
  [PAGE_NAME.PENDING_PROFILE_DATA]: URLS.PENDING_APPROVAL_PROFILE,
  [PAGE_NAME.APPROVED_OR_REJECTED_PROFILE]: URLS.APPROVED_USERS_LIST,
  [PAGE_NAME.ATTENDANCE_RECORD]: URLS.ATTENDANCE_LIST,
  [PAGE_NAME.ATTENDANCE_RECORD_BY_MONTH]: URLS.ATTENDANCE_BY_MONTH_LIST,
  [PAGE_NAME.SUPERVISOR_ASSIGNMENT]: URLS.SUPERVISOR_ASSIGNMENT_LIST,
  [PAGE_NAME.BULK_SUPERVISOR_ASSIGNMENT]: URLS.BULK_SUPERVISOR_ASSIGN,
  [PAGE_NAME.ERML_FILE_DOWNLOAD]: URLS.ERML_SUBMISSION,
  [PAGE_NAME.ERML_SETTINGS]: URLS.ERML_SETTINGS,
  [PAGE_NAME.ATTENDANCE_METHOD]: URLS.ATTENDANCE_METHOD,
  [PAGE_NAME.ATTENDANCE_TYPE]: URLS.ATTENDANCE_TYPE,
  [PAGE_NAME.PUSH_NOTIFICATION]: URLS.MESSAGE_NOTIFICATION,
  [PAGE_NAME.NON_WORKING_DAY]: URLS.NON_WORKING_DAY_GLOBAL,
  [PAGE_NAME.ESTATE]: URLS.ESTATE,
  [PAGE_NAME.ESTATE_FILE_UPLOAD]: URLS.ESTATE_UPLOAD,
  [PAGE_NAME.ESTATE_QR]: URLS.ESTATE,
  [PAGE_NAME.SOS_RECORD]: URLS.SOS_LIST,
  [PAGE_NAME.DAILY_SUBMISSION_LIMIT]: URLS.SOS_COUNT,
  [PAGE_NAME.SOS_RECIPIENT]: URLS.SOS_RECIPIENT,
  [PAGE_NAME.GRIEVANCE_RECORDS]: URLS.GRIEVANCE_LIST,
  [PAGE_NAME.ASSIGNEE]: URLS.GRIEVANCE_ASSIGNEE,
  [PAGE_NAME.MOBILE_CHANGE]: URLS.MOBILE_NUMBER_CHANGE,
  [PAGE_NAME.NEW_USER_REQUEST]: URLS.NEW_USER_REQUEST,
  [PAGE_NAME.FEATURE_CONTROL]: URLS.FEATURE_CONTROL_MODULE,
  [PAGE_NAME.UPLOAD_FILE_SIZE_SETTING]: URLS.UPLOAD_SIZE,
  [PAGE_NAME.AUDIO_SETTING]: URLS.AUDIO_SETTINGS,
  [PAGE_NAME.MAX_TRANSLATION_COUNT]: URLS.TRANSLATION_COUNT,
  [PAGE_NAME.NOTIFICATION_SETTING]: URLS.PUSH_NOTIFICATION_SETTINGS,
  [PAGE_NAME.CUSTOM_FIELD]: URLS.ID_TYPE_CUSTOM_FIELDS,
  [PAGE_NAME.SMTP_SETTINGS]: URLS.SMTP_SETTINGS,
  [PAGE_NAME.FORCE_UPDATE_SETTINGS]: URLS.FORCE_UPDATE_SETTINGS,
  [PAGE_NAME.ATTENDANCE_WORKER_GROUP]: URLS.ATTENDANCE_WORKER_GROUP,
  [PAGE_NAME.AUDIT_ROLE_SETUP]: URLS.AUDIT_ROLE_SETUP,
  [PAGE_NAME.AUDIT_ATTENDANCE_SETUP]: URLS.AUDIT_ATTENDANCE_SETUP,
  [PAGE_NAME.AUDIT_CUSTOM_SETUP]: URLS.AUDIT_CUSTOM_SETUP,
  [PAGE_NAME.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_TYPE]:
    URLS.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_TYPE,
  [PAGE_NAME.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_METHOD]:
    URLS.AUDIT_ATTENDANCE_SETUP_ATTENDANCE_METHOD,
  [PAGE_NAME.AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY]:
    URLS.AUDIT_ATTENDANCE_SETUP_NON_WORKING_DAY,
  [PAGE_NAME.AUDIT_CUSTOM_SETUP_WORKER_GROUP]:
    URLS.AUDIT_CUSTOM_SETUP_WORKER_GROUP,
  [PAGE_NAME.AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE]:
    URLS.AUDIT_CUSTOM_SETUP_GRIEVANCE_TYPE,
  [PAGE_NAME.AUDIT_CUSTOM_SETUP_URGENCY_LEAVE]:
    URLS.AUDIT_CUSTOM_SETUP_URGENCY_LEAVE,
  [PAGE_NAME.AUDIT_AUDIO_SETUP]: URLS.AUDIT_AUDIO_SETUP,
  [PAGE_NAME.AUDIT_TRANSLATION_COUNT]: URLS.AUDIT_TRANSLATION_COUNT,
  [PAGE_NAME.AUDIT_SOS_TRANSACTION]: URLS.AUDIT_SOS_TRANSACTION,
  [PAGE_NAME.AUDIT_GRIEVANCE_TRANSACTION]: URLS.AUDIT_GRIEVANCE_TRANSACTION,
  

  [PAGE_NAME.SMS_REPORT]: URLS.SMS_REPORT,
  [PAGE_NAME.AUDIT_TRIAL_USER]:URLS.AUDIT_TRIAL_USER,
  [PAGE_NAME.WORKER_ACCESS_REPORT]: URLS.WORKER_ACCESS_REPORT,
};

export const TRANSLATION_DISCLAIMER_MESSAGE =
  "This service may contain translations powered by Google. Google disclaims all warranties related to the translations, expressed or implied, including any warranties of accuracy, reliability, and any implied warranties of merchantability, fitness for a particular purpose, and noninfringement.";
export const SUPERVISOR_DISCLAIMER_MESSAGE =
  "These Buttons only applicable for Role Supervisor only.";